import mengapaDanai1 from "../../assets/img/mengapa-danai/why-danai-2.png";
import mengapaDanai2 from "../../assets/img/mengapa-danai/why-danai-3.png";
import mengapaDanai0 from "../../assets/img/mengapa-danai/why-danai-1.png";
import {Accordion, AccordionTab} from "primereact/accordion";
import React, {useState} from "react";

export default function MengapaDanaiSection(){
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className="container-1">
            <div className="section-img">
                <img src={activeIndex === 1 ? mengapaDanai1 : activeIndex === 2 ? mengapaDanai2 : mengapaDanai0}
                     id="myImage" alt='mengapa danai'/>
            </div>
            <div className="section-txt">
                <div className="section-title">
                    <h1 className="text-header">Mengapa <span>Danai.id</span> adalah Pilihan Terbaik Anda?</h1>
                    <p>Tinjau alasan kuat untuk meningkatkan pengalaman finansial Anda dengan keunggulan yang
                        membuat kami menonjol diantara pilihan fintech lainnya.</p>
                </div>
                <div className="text-accordion">
                    <Accordion 
                            activeIndex={activeIndex} 
                            onTabChange={(e) => setActiveIndex(e.index)}
                            transitionOptions={{ timeout: 0 }}>
                        <AccordionTab header="Prioritas Pelayanan untuk Anda">
                            <p>Prioritas kami adalah memberikan pelayanan yang optimal kepada Anda, baik sebagai
                                Peminjam yang membutuhkan dana tambahan maupun sebagai Pemberi Pinjaman yang ingin
                                mempunyai alternatif investasi yang dapat menguntungkan.</p>
                        </AccordionTab>

                        <AccordionTab header="Pengelolaan Keuangan dengan Metode Terbaik">
                            <p>
                                Kami mengaplikasikan praktek industri terbaik dalam pengelolaan pelayanan keuangan
                                Anda, serta menjaga kepercayaan Anda terhadap Danai.id </p>
                        </AccordionTab>

                        <AccordionTab header="Imbal Hasil yang Menarik & Terukur">
                            <p>
                                Nikmati imbal hasil yang menarik sebagai Pemberi Pinjaman, yang disertai evaluasi
                                risiko yang
                                cermat untuk memastikan bahwa investasi Anda aman dan menguntungkan </p>
                        </AccordionTab>
                    </Accordion>
                </div>
                <a href='/tentang-kami' className="btn-danai green-outline">
                    Lebih lanjut tentang kami
                </a>
            </div>
        </div>
    );
}